<template>
  <div class="term">
    <h1>RETURN & REFUND POLICY</h1>

    <h2>RETURN COSTS AND RESPONSIBILITY</h2>

    <div>
      You have the right to return any/all products you have purchased directly
      from our website within 7 days of receiving the products. Before returning
      the products, kindly read through “Return Procedures” first. The return of
      products is considered legit after the relevant department reviews and
      approves your request.
    </div>
    <div>
      The buyer bears the costs of returning his/her order. The buyer is
      responsible for preparing and shipping the return shipment. We strongly
      advise any buyer who wants to return his/her order to choose a secured
      shipment method. Return shipments take place at the risk of the buyer.
    </div>

    <h2>RETURN PROCEDURES</h2>

    <div>
      Before you return the products, you are required to contact with our
      Product Return Department to initiate the return procedure by emailing the
      below details to info@cel-elements.com.my.
      <ul>
        <li>Invoice number</li>
        <li>Your First and Last Name</li>
        <li>Registered Email</li>
        <li>A photoshoot of the affected product</li>
      </ul>
    </div>
    <div>
      After the relevant department reviews and approves your return request,
      you can move on to ship the products back to the address provided by the
      customer care representative or to the address below:
      <p class="mt-2 ml-2">
        Cel-Elements Holdings (M) Sdn. Bhd.<br/>
        No. 44, Jalan Puteri 7/7,<br/>
        Bandar Puteri Puchong,<br/>
        47100 Puchong,<br/>
        Selangor Darul Ehsan.<br/>
        +603-8060 7610<br/>
      </p>
    </div>

    <h2>REFUND</h2>

    <div>
      After we have received and approved your request, we will refund your
      product(s) for its full value to the account originally used when making
      your purchase. The refund for the item(s) does not include any shipping
      and handling charges, or any other fees. Processing of refunds may take up
      to 30 business days from the date the returned package is received.
    </div>
  </div>
</template>
<style>
.term h1,
.term h2 {
  @apply mb-2;
}

.term div {
  @apply mb-4;
}
</style>
